import React from 'react';


const FormDropdown = ({list, addItem}) => {


   return (<div id="dropdown"
                className="absolute shadow selector-dark top-100 h-72 bg-white z-40 w-full lef-0 rounded max-h-select overflow-y-auto ">
      <div className="flex flex-col w-full">
         {list.map((item, key) => {
            return (
               <div key={key}
                    className="cursor-pointer selector-dark w-full border-gray-100 rounded-t border-b hover:bg-blue-100"
                    onClick={() => addItem(item)}>
                  <div
                     className="flex w-full items-center p-2 pl-2 border-transparent border-l-2 relative hover:border-teal-100">
                     <div className="w-full items-center flex">
                        <div className="mx-2 leading-6  ">
                           {item.label}
                        </div>
                     </div>
                  </div>
               </div>)
         })}
      </div>
   </div>);

};

export default FormDropdown;